// Substitui os últimos 4 dígitos por '*' quando a string parece ser um número
// de telefone (>= 8 dígitos e composta majoritariamente por dígitos).
// Strings que não parecem telefone (nomes humanos) são retornadas inalteradas.
const maskPhoneLast4 = (value) => {
	if (!value) return value;
	const str = String(value);
	const digits = str.match(/\d/g) || [];
	const compactLen = str.replace(/\s/g, "").length || 1;
	const looksLikePhone = digits.length >= 8 && digits.length / compactLen >= 0.7;
	if (!looksLikePhone) return str;

	let masked = str;
	let replaced = 0;
	for (let i = str.length - 1; i >= 0 && replaced < 4; i--) {
		if (/\d/.test(masked[i])) {
			masked = masked.substring(0, i) + "*" + masked.substring(i + 1);
			replaced++;
		}
	}
	return masked;
};

export default maskPhoneLast4;
